// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__1RaB5","title":"Menu_title__1AnIG","link":"Menu_link__22GzB","active":"Menu_active__CG68Z"};